export default __webpack_public_path__ + "static/media/02AW2JUL66.296de10b.jpg";